module.exports = __webpack_public_path__ + "static/media/pen.104bf02c.svg";